<template>
    <div class="Modal" v-if="show">
        <div class="Modal__heading"><slot name="heading"></slot></div>
        <div class="Modal__body"><slot></slot></div>
        <div class="Modal__controls">
            <ul class="Utility__list-inline">
                <li><a href="#" class="Button Button--danger" @click.prevent="no">{{ noText }}</a></li>
                <li><a href="#" class="Button" @click.prevent="onYes">{{ yesText }}</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                show: false,
            }
        },

        props: {
            onYes: {
                required: true,
                type: Function,
            },

            onNo: {
                type: Function,
            },

            yesText: {
                default: 'Yes',
                type: String
            },

            noText: {
                default: 'No',
                type: String
            }
        },

        watch: {
            show: (show) => {
                if (show) {
                    bus.$emit('show-overlay', false, false);
                } else {
                    bus.$emit('hide-overlay');
                }
            }
        },

        methods: {
            no() {
                if (typeof this.onNo != 'undefined') {
                    return this.onNo();
                }

                this.show = false;
            }
        }
    }
</script>